import { YhAuth } from '@/components/auth/YhAuth';
import { YhBox } from '@/components/YhBox';
import { DescriptionColorEnum, IDescription } from '@/components/YhBox/Types';
import useGlobalModel from '@/model/globalModel';
import { DictCodeEnmu } from '@/types/FmsDictEnums';
import { ResourceAuthEnum } from '@/types/FmsResourceAuthEnum';
import { beService } from '@/views/base/be/beService';
import { dictService } from '@/views/base/dict/dictService';
import { orgService } from '@/views/base/org/orgService';
import { labelsType } from '@/views/cash/pay/cashPayModel';
import { Button, Spin } from 'antd';
import React, { useEffect } from 'react'
import { BillDataTable } from './DataTable';
import { PageHeader } from './PageHeader';
import { useStatisticPurchaseModel } from './statisticPayableModel';

export const StatisticPayable = () => {

  const {
    spinning,
    dataSource,
    pgCfg,
    selectedRowKeys,
    billSummaryData,
    setOrgDs,
    setBeDs,
    setPayMethodLabels,
    setSelectedData,
    loadData,
    billCustomerExport,
    exportLoading,
  } = useStatisticPurchaseModel(model => [model.billSummaryData, model.exportLoading])

  const { getSelectedDict } = useGlobalModel(() => []);

  useEffect(() => {
    let obj: labelsType = {}
    orgService.orgTreeDs({}).then(ds => setOrgDs(ds))
    beService.beDs({}).then(ds => setBeDs(ds))
    getSelectedDict(DictCodeEnmu.SETTLE_TYPE).forEach(item => {
      obj[item.value] = item.label
    })
    setPayMethodLabels(obj);


    loadData({ pageNum: 1 }).then()
  }, []);



  useEffect(() => {
    let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
    const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
    setSelectedData(selectedData)
  }, [selectedRowKeys]);

  const desc: IDescription[] = [
    // {
    //   label: "采退单数",
    //   value: pgCfg.total?.toFixed(2) ?? 0.00,
    //   color: DescriptionColorEnum.green
    // },
    // {
    //   label: "销售单数",
    //   value: billSummaryData?.totalWriteoffAmount?.toFixed(2) ?? 0.00,
    //   color: DescriptionColorEnum.green
    // },
    {
      label: "应付金额",
      value: billSummaryData?.totalBillAmount?.toFixed(2) ?? 0.00,
      color: DescriptionColorEnum.red
    },
  ]



  const action = (
    <>
      <div>
        {/* <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onWriteoff}
                >
                    核销
                </Button> */}
        <YhAuth resCode={ResourceAuthEnum.BILL_C_EX}>
          <Button
            className="mr-5"
            type="link"
            shape="round"
            loading={exportLoading}
            onClick={billCustomerExport}
            disabled={spinning}
          >
            导出
          </Button>
        </YhAuth>
      </div>

    </>
  );

  return (
    <>
      <PageHeader />
      <YhBox title={"应付报表"} descriptions={desc} action={action}>
        <BillDataTable />
      </YhBox>
    </>
  )
}